








































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import BuilderDeviceHighlight from '@/components/builder/BuilderDeviceHighlight.vue'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'

@Component({
  components: {
    BuilderDeviceHighlight,
    vueCustomScrollbar,
  },
  computed: {
    ...mapGetters('builder', { getApp: 'getApp' }),
  },
})
export default class BuilderMobileDevice extends Vue {
  scrollbarSettings = {
    suppressScrollY: false,
    suppressScrollX: false,
    wheelPropagation: false,
  }

  getApp!: any
  @Prop({ default: process.env.VUE_APP_INSTA_APP_DOMAIN, type: String }) domainName!: string

  @Prop({ type: String }) siteName!: string
  @Prop({ type: String }) color!: string

  @Prop({ default: false, type: Boolean }) highlight!: boolean

  @Prop({ default: false, type: Boolean }) viewMode!: boolean

  get pathname(): string {
    return this.getApp?.name || this.siteName
  }
}
